import { render, staticRenderFns } from "./DodatnaAktivnostBase.vue?vue&type=template&id=796b1431&scoped=true&"
import script from "./DodatnaAktivnostBase.vue?vue&type=script&lang=js&"
export * from "./DodatnaAktivnostBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796b1431",
  null
  
)

export default component.exports